export const Paths = {
  home: '/',
  menu: '/menu',
  createScheduledContent: '/scheduled-content/create',
  listScheduledContent: '/scheduled-content/list',
  publicationWall: '/dashboard/publicacoes/mural',
  classification: '/dashboard/publicacoes/classificar',
  overview: '/dashboard/resumo/visaogeral',
  header: '/header',
  headerMenu: '/header-menu',
  globalFilter: '/global-filter',
  accountManager: '/account-manager',
  central: '/central',
  newSetup: '/new-setup',
  metricsMenu: '/metrics-menu',
};
